import { useState } from "react";
import { useForm } from "react-hook-form";
import { PrimeIcons } from "primereact/api";
import { Button } from "primereact/button";

import { addNewProject, checkLastResetChat } from "services";
import { useSnackbar } from "providers/SnackbarProvider";
import { useConfirmDialogExit } from "hooks";

import {
  SingleStepDialog,
  SingleStepHeaders,
  SingleStepBody,
  SingleStepFooter,
} from "components/SingleStepDialog";
import {
  buttonNewProject,
  modalAddProjectSubTitle,
  snackbarSummarySuccessAddProject,
  formAddProject,
  modalNewProjectTitle,
  snackbarSummarySuccessAddProjectSubTitlePart1,
  snackbarSummarySuccessAddProjectSubTitlePart2,
  snackbarSummaryResetChatSubTitle,
  snackbarResetChat,
} from "_constants";
import { FormAddProject } from "components/form/FormAddProject";
import { useAppDispatch } from "store/store";
import { setPageProjects } from "store/slicer/GestioneProjectsSlice";
import { useNavigate } from "react-router-dom";
import { resetStateChat, setCheckInactiveAnswers } from "store/slicer/GestioneChatSlice";
import { resetInitialStateDetailProject } from "store/slicer/GestioneDetailProjectSlice";

export const ButtonAddProject = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const { showSnackbar } = useSnackbar();
  const { showConfirmDialogExit } = useConfirmDialogExit();
  const showSingleStepDialog = () => {
    setVisible(true);
  };

  const { handleSubmit, control, trigger } = useForm({
    defaultValues: {
      name: "",
    },
    shouldFocusError: false,
    mode: "onChange",
  });
  const onSubmit = (formData: any) => {
    addNewProject(formData)
      .then((response) => {
        checkLastResetChat(response.data.id).then((res) => {
          if (res.data.canShowWarning) {
            dispatch(setCheckInactiveAnswers(true));
            showSnackbar({
              severity: "warn",
              summary: snackbarResetChat,
              detail: snackbarSummaryResetChatSubTitle,
              life: 5000,
            });
          }
        }).catch((_) => { });
        showSnackbar({
          severity: "success",
          summary: snackbarSummarySuccessAddProject,
          detail: `${snackbarSummarySuccessAddProjectSubTitlePart1}"${formData.name}"${snackbarSummarySuccessAddProjectSubTitlePart2}`,
          life: 5000,
        });
        dispatch(setPageProjects(-1));
        setTimeout(() => {
          dispatch(setPageProjects(1));
        }, 200);
        dispatch(resetStateChat());
        dispatch(resetInitialStateDetailProject());
        navigate(`/bo/project?id=${response.data.id}`);
        resetFormState();
      })
      .catch((_) => { });
  };

  const handleDismiss = () => {
    if (control._getDirty()) {
      showConfirmDialogExit({ rejectCallback: resetFormState });
    } else {
      resetFormState();
    }
  };

  const resetFormState = () => {
    control._reset();
    setVisible(false);
  };

  return (
    <>
      <Button
        label={buttonNewProject}
        icon={PrimeIcons.PLUS}
        onClick={showSingleStepDialog}
      />
      <SingleStepDialog
        onHideCallback={handleDismiss}
        height="auto"
        width="700px"
        header={
          <SingleStepHeaders
            title={modalNewProjectTitle}
            subtitle={modalAddProjectSubTitle}
          />
        }
        body={
          <SingleStepBody
            content={
              <form
                id={formAddProject}
                onSubmit={handleSubmit(onSubmit)}
                className="width-100"
              >
                <FormAddProject control={control} trigger={trigger} />
              </form>
            }
          />
        }
        footer={
          <SingleStepFooter dismiss={handleDismiss} form={formAddProject} />
        }
        display={visible}
        setVisible={setVisible}
      />
    </>
  );
};
